import _ from 'lodash';
import { connect } from 'react-redux';
import { search, searchLogs, advancedSearch } from '../../modules/accounting/bulkInvoice';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state, ownProps) => {

	/** @namespace state.lists.bulkInvoiceIds **/
	/** @namespace state.maps.bulkInvoice **/
	/** @namespace state.maps.user **/
	let pendingBulkInvoices = undefined;
	let invalidBulkInvoices = undefined;
	let issuedBulkInvoices  = undefined;
	if (state.bulkInvoices.byStatus) {
		const { pending, invalid, issued } = state.bulkInvoices.byStatus;
		if (pending) {
			pendingBulkInvoices = _.map(pending, id => state.maps.bulkInvoice[id]);
		}
		if (invalid) {
			invalidBulkInvoices = _.map(invalid, id => state.maps.bulkInvoice[id]);
		}
		if (issued) {
			issuedBulkInvoices = _.map(issued, id => state.maps.bulkInvoice[id]);
		}
	}

	let bulkInvoice;
	let bulkInvoiceId;

	if (ownProps.bulkInvoice) {
		bulkInvoice = ownProps.bulkInvoice;
		bulkInvoiceId = bulkInvoice.bulkInvoiceId;
	} else {
		bulkInvoiceId = (ownProps.bulkInvoiceId)
			? ownProps.bulkInvoiceId
			: _.get(ownProps, ['match', 'params', 'bulkInvoiceId']);
		bulkInvoice = _.get(state.maps, ['bulkInvoice', bulkInvoiceId]);
	}


	let bulkInvoiceLogs = [];
	/** @namespace state.lists.bulkInvoiceLogIds **/
	/** @namespace state.lists.bulkInvoiceLog **/

	if (
		state.lists.bulkInvoiceLogIds &&
		state.lists.bulkInvoiceLogIds[bulkInvoiceId]
	) {
		bulkInvoiceLogs = _.map(state.lists.bulkInvoiceLogIds[bulkInvoiceId],
			id => state.maps.bulkInvoiceLog[id]
		);
	}

	const canMakeUpdates = !!(_.get(state.auth.authUser, ['permissions', 'canMakeUpdates'], false));
	return {
		bulkInvoice,
		bulkInvoiceLogs,
		pendingBulkInvoices,
		invalidBulkInvoices,
		issuedBulkInvoices,
		userMap : state.maps.user,
		bulkCustomerMap : state.maps.bulkCustomer,
		supplierMap : state.maps.supplier,
		terminalMap : state.maps.terminal,
		carrierMap : state.maps.carrier,
		resourceMap : state.maps.resource,
		invoiceDocumentMap : state.maps.invoiceDocument,
		bulkDeliveryMap : state.maps.bulkDelivery,
		canMakeUpdates,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	advancedSearchBulkInvoices : advancedSearch,
	searchBulkInvoices : search,
	searchBulkInvoiceLogs : searchLogs,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
